import { BooleanIcon, CategoryIcon, ChoiceIcon, DecimalIcon, DownArrowIcon, FractionIcon, IntegerIcon, MultiChoiceIcon, SubModelIcon, TextIcon, UpArrowIcon } from "assests/GmsIcons";
import React, { useContext, useEffect, useState } from "react";
import { SB3RuleContext } from "../Rules/SB3RuleContext";
import {TNode} from "./dataTypes";

type TSidePanelElementCardProps = {
    submodel: any;
    field: any;
    item: any;
    expanded: boolean;
    indent?: number;
    setExpanded: React.Dispatch<React.SetStateAction<boolean>>
};

const SidePanelElementCard = ({submodel, field, item, expanded, setExpanded, indent }: TSidePanelElementCardProps) => {
    const { selectedIds, handleCheckBox, sidepanelType, handleMathExp, showPickPanel } = useContext(SB3RuleContext);
    const [checked, setChecked] = useState(false)

    useEffect(() => {
        let isChecked = false;
        let selected:TNode[] = selectedIds?.filter((node: TNode) => {
            if(node.type === 'choice') {
                if (node.submodel === item.submodel && node.field === item.field && node.type === item.type && item.name === node.name) {
                    return true;
                } else {
                    return false;
                }
            }
            return node.id === `${item.id}`;
        });
        if(selected.length > 0) {
            const id:TNode = selected[0];
            if(id.type === 'choice') {
                if (id.submodel === item.submodel && id.field === item.field && id.type === item.type && item.name === id.name) {
                    isChecked = true;
                }
            } else {
                if (id.id === item.id) {
                    isChecked = true;
                }
            }
        }
        setChecked(isChecked)
    }, [selectedIds, showPickPanel])

    return (
        <>
            <div
                className={`tw-ml-2 tw-w-[237px] tw-border tw-border-zinc-300/opacity-50 tw-flex tw-justify-between ${checked ? "tw-bg-indigo-50" : "tw-bg-white"} tw-cursor-pointer `}
            >
                <div role="button" data-testid="rulecomponents-sidepanelelementcard-div-1" className="tw-flex"
                    onClick={sidepanelType === "math" ? (e) => {
                        handleMathExp(item)
                    } : () => { }}
                >
                    {sidepanelType !== "math" && <input data-testid="rulecomponents-sidepanelelementcard-input-1"
                        type="checkbox"
                        className="tw-w-3 tw-h-4 tw-bg-white tw-rounded tw-border tw-border-neutral-300 tw-m-1"
                        id={item?.id}
                        value={item?.id}
                        checked={checked}
                        onChange={() => { handleCheckBox(submodel, field, item, !checked); setChecked(prev => !prev) }}
                    />}
                    <span className={`tw-flex tw-ml-${indent}`}>
                        <div className={`${(item?.type === "choice" || item?.type === "product") ? 'tw-m-2' : 'tw-m-1'} tw-mr-2`}>
                            {item?.type === "submodel" ? <SubModelIcon /> : null}
                            {item?.type === "multi-choice" ? <MultiChoiceIcon /> : null}
                            {item?.type === "text" ? <TextIcon /> : null}
                            {item?.type === "decimal" ? <DecimalIcon /> : null}
                            {item?.type === "fraction" ? <FractionIcon /> : null}
                            {item?.type === "integer" ? <IntegerIcon /> : null}
                            {item?.type === "boolean" ? <BooleanIcon /> : null}
                            {item?.type === "choice" ? <ChoiceIcon /> : null}
                            {item?.type === "product" ? <ChoiceIcon /> : null}
                            {item?.type === "category" ? <CategoryIcon /> : null}

                        </div>
                        {item?.displayValue ?? item?.name}
                    </span>
                </div>

                {(item?.fields?.length > 0 || item?.categories?.length > 0 || item?.type === "multi-choice")
                    ?
                    <span role="button" data-testid="rulecomponents-sidepanelelementcard-span-2" onClick={() => setExpanded((prev) => !prev)}
                        className="tw-m-2">
                        {expanded ? <UpArrowIcon /> : <DownArrowIcon />}
                    </span> 
                    :
                    null

                }
            </div>
        </>
    );
};

export default SidePanelElementCard;
